module.exports = __webpack_public_path__ + "static/media/landing_background.73067372.png";